'use strict';
'use es6';

/*
* Note - this interface is intended only to
* encapsulate debug log + error message formatting.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var createLog = function createLog(type, name, message) {
  return '\nusage-tracker ' + type + ': "' + name + '"\n----------------------------------------\n' + message + '\n';
};

var debugLog = exports.debugLog = function debugLog(name, properties) {
  return createLog('debug log', name, Object.keys(properties).reduce(function (accumulator, key) {
    var value = properties[key];
    if (typeof value === 'string') {
      accumulator += key + ': ' + value + '\n';
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      accumulator += key + ': ' + JSON.stringify(value, null, 2) + '\n';
    } else {
      accumulator += key + ': ' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '\n';
    }
    return accumulator;
  }, ''));
};

var genericError = exports.genericError = function genericError(message) {
  return new Error('usage-tracker error: ' + message);
};

var configError = exports.configError = function configError(message) {
  return new Error('usage-tracker config error: ' + message);
};

var eventError = exports.eventError = function eventError(message) {
  return new Error('usage-tracker event error: ' + message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/common/messages.js
// module id = 246
// module chunks = 3